{
    "1": {
        "nombreRegion": "Región de Tarapacá",
        "comunas": [
            {
                "comuna": "ALTO HOSPICIO",
                "codigo": 1107,
                "ciudad": "IQUIQUE"
            },
            {
                "comuna": "IQUIQUE",
                "codigo": 1101,
                "ciudad": "IQUIQUE"
            },
            {
                "comuna": "CAMINA",
                "codigo": 1402,
                "ciudad": "CAMINA"
            },
            {
                "comuna": "COLCHANE",
                "codigo": 1403,
                "ciudad": "ARICA"
            },
            {
                "comuna": "HUARA",
                "codigo": 1404,
                "ciudad": "IQUIQUE"
            },
            {
                "comuna": "PICA",
                "codigo": 1405,
                "ciudad": "IQUIQUE"
            },
            {
                "comuna": "POZO ALMONTE",
                "codigo": 1401,
                "ciudad": "IQUIQUE"
            }
        ]
    },
    "2": {
        "nombreRegion": "Región de Antofagasta",
        "comunas": [
            {
                "comuna": "SIERRA GORDA",
                "codigo": 2103,
                "ciudad": "SIERRA GORDA"
            },
            {
                "comuna": "TALTAL",
                "codigo": 2104,
                "ciudad": "TALTAL"
            },
            {
                "comuna": "CALAMA",
                "codigo": 2201,
                "ciudad": "CALAMA"
            },
            {
                "comuna": "OLLAGUE",
                "codigo": 2202,
                "ciudad": "OLLAGUE"
            },
            {
                "comuna": "SAN PEDRO DE ATACAMA",
                "codigo": 2203,
                "ciudad": "SAN PEDRO DE ATACAMA"
            },
            {
                "comuna": "TOCOPILLA",
                "codigo": 2301,
                "ciudad": "TOCOPILLA"
            },
            {
                "comuna": "MARIA ELENA",
                "codigo": 2302,
                "ciudad": "MARIA ELENA"
            },
            {
                "comuna": "ANTOFAGASTA",
                "codigo": 2101,
                "ciudad": "ANTOFAGASTA"
            },
            {
                "comuna": "MEJILLONES",
                "codigo": 2102,
                "ciudad": "MEJILLONES"
            }
        ]
    },
    "3": {
        "nombreRegion": "Región de Atacama",
        "comunas": [
            {
                "comuna": "COPIAPO",
                "codigo": 3101,
                "ciudad": "COPIAPO"
            },
            {
                "comuna": "CALDERA",
                "codigo": 3102,
                "ciudad": "CALDERA"
            },
            {
                "comuna": "TIERRA AMARILLA",
                "codigo": 3103,
                "ciudad": "TIERRA AMARILLA"
            },
            {
                "comuna": "CHANARAL",
                "codigo": 3201,
                "ciudad": "CHANARAL"
            },
            {
                "comuna": "DIEGO DE ALMAGRO",
                "codigo": 3202,
                "ciudad": "DIEGO DE ALMAGRO"
            },
            {
                "comuna": "VALLENAR",
                "codigo": 3301,
                "ciudad": "VALLENAR"
            },
            {
                "comuna": "ALTO DEL CARMEN",
                "codigo": 3302,
                "ciudad": "ALTO DEL CARMEN"
            },
            {
                "comuna": "FREIRINA",
                "codigo": 3303,
                "ciudad": "FREIRINA"
            },
            {
                "comuna": "HUASCO",
                "codigo": 3304,
                "ciudad": "HUASCO"
            }
        ]
    },
    "4": {
        "nombreRegion": "Región de Coquimbo",
        "comunas": [
            {
                "comuna": "LOS VILOS",
                "codigo": 4203,
                "ciudad": "LOS VILOS"
            },
            {
                "comuna": "SALAMANCA",
                "codigo": 4204,
                "ciudad": "SALAMANCA"
            },
            {
                "comuna": "OVALLE",
                "codigo": 4301,
                "ciudad": "OVALLE"
            },
            {
                "comuna": "COMBARBALA",
                "codigo": 4302,
                "ciudad": "COMBARBALA"
            },
            {
                "comuna": "MONTE PATRIA",
                "codigo": 4303,
                "ciudad": "MONTE PATRIA"
            },
            {
                "comuna": "PUNITAQUI",
                "codigo": 4304,
                "ciudad": "PUNITAQUI"
            },
            {
                "comuna": "RIO HURTADO",
                "codigo": 4305,
                "ciudad": "RIO HURTADO"
            },
            {
                "comuna": "LA SERENA",
                "codigo": 4101,
                "ciudad": "LA SERENA"
            },
            {
                "comuna": "COQUIMBO",
                "codigo": 4102,
                "ciudad": "COQUIMBO"
            },
            {
                "comuna": "ANDACOLLO",
                "codigo": 4103,
                "ciudad": "ANDACOLLO"
            },
            {
                "comuna": "LA HIGUERA",
                "codigo": 4104,
                "ciudad": "LA HIGUERA"
            },
            {
                "comuna": "PAIHUANO",
                "codigo": 4105,
                "ciudad": "PAIHUANO"
            },
            {
                "comuna": "VICUNA",
                "codigo": 4106,
                "ciudad": "VICUNA"
            },
            {
                "comuna": "ILLAPEL",
                "codigo": 4201,
                "ciudad": "ILLAPEL"
            },
            {
                "comuna": "CANELA",
                "codigo": 4202,
                "ciudad": "CANELA"
            }
        ]
    },
    "5": {
        "nombreRegion": "Región de Valparaíso",
        "comunas": [
            {
                "comuna": "VALPARAISO",
                "codigo": 5101,
                "ciudad": "VALPARAISO"
            },
            {
                "comuna": "CASABLANCA",
                "codigo": 5102,
                "ciudad": "CASABLANCA"
            },
            {
                "comuna": "CONCON",
                "codigo": 5103,
                "ciudad": "CONCON"
            },
            {
                "comuna": "JUAN FERNANDEZ",
                "codigo": 5104,
                "ciudad": "JUAN FERNANDEZ"
            },
            {
                "comuna": "PUCHUNCAVI",
                "codigo": 5105,
                "ciudad": "PUCHUNCAVI"
            },
            {
                "comuna": "QUILPUE",
                "codigo": 5801,
                "ciudad": "QUILPUE"
            },
            {
                "comuna": "QUINTERO",
                "codigo": 5107,
                "ciudad": "QUINTERO"
            },
            {
                "comuna": "VILLA ALEMANA",
                "codigo": 5804,
                "ciudad": "VILLA ALEMANA"
            },
            {
                "comuna": "VINA DEL MAR",
                "codigo": 5109,
                "ciudad": "VINA DEL MAR"
            },
            {
                "comuna": "ISLA DE PASCUA",
                "codigo": 5201,
                "ciudad": "ISLA DE PASCUA"
            },
            {
                "comuna": "LOS ANDES",
                "codigo": 5301,
                "ciudad": "LOS ANDES"
            },
            {
                "comuna": "CALLE LARGA",
                "codigo": 5302,
                "ciudad": "LOS ANDES"
            },
            {
                "comuna": "RINCONADA",
                "codigo": 5303,
                "ciudad": "RINCONADA"
            },
            {
                "comuna": "SAN ESTEBAN",
                "codigo": 5304,
                "ciudad": "SAN ESTEBAN"
            },
            {
                "comuna": "LA LIGUA",
                "codigo": 5401,
                "ciudad": "LA LIGUA"
            },
            {
                "comuna": "CABILDO",
                "codigo": 5402,
                "ciudad": "CABILDO"
            },
            {
                "comuna": "PAPUDO",
                "codigo": 5403,
                "ciudad": "PAPUDO"
            },
            {
                "comuna": "PETORCA",
                "codigo": 5404,
                "ciudad": "PETORCA"
            },
            {
                "comuna": "ZAPALLAR",
                "codigo": 5405,
                "ciudad": "ZAPALLAR"
            },
            {
                "comuna": "QUILLOTA",
                "codigo": 5501,
                "ciudad": "QUILLOTA"
            },
            {
                "comuna": "CALERA",
                "codigo": 5502,
                "ciudad": "CALERA"
            },
            {
                "comuna": "HIJUELAS",
                "codigo": 5503,
                "ciudad": "HIJUELAS"
            },
            {
                "comuna": "LA CRUZ",
                "codigo": 5504,
                "ciudad": "LA CRUZ"
            },
            {
                "comuna": "LIMACHE",
                "codigo": 5802,
                "ciudad": "LIMACHE"
            },
            {
                "comuna": "NOGALES",
                "codigo": 5506,
                "ciudad": "NOGALES"
            },
            {
                "comuna": "OLMUE",
                "codigo": 5803,
                "ciudad": "OLMUE"
            },
            {
                "comuna": "SAN ANTONIO",
                "codigo": 5601,
                "ciudad": "SAN ANTONIO"
            },
            {
                "comuna": "ALGARROBO",
                "codigo": 5602,
                "ciudad": "ALGARROBO"
            },
            {
                "comuna": "CARTAGENA",
                "codigo": 5603,
                "ciudad": "CARTAGENA"
            },
            {
                "comuna": "EL QUISCO",
                "codigo": 5604,
                "ciudad": "EL QUISCO"
            },
            {
                "comuna": "EL TABO",
                "codigo": 5605,
                "ciudad": "EL TABO"
            },
            {
                "comuna": "SANTO DOMINGO",
                "codigo": 5606,
                "ciudad": "SANTO DOMINGO"
            },
            {
                "comuna": "SAN FELIPE",
                "codigo": 5701,
                "ciudad": "SAN FELIPE"
            },
            {
                "comuna": "CATEMU",
                "codigo": 5702,
                "ciudad": "CATEMU"
            },
            {
                "comuna": "LLAILLAY",
                "codigo": 5703,
                "ciudad": "LLAILLAY"
            },
            {
                "comuna": "PANQUEHUE",
                "codigo": 5704,
                "ciudad": "PANQUEHUE"
            },
            {
                "comuna": "PUTAENDO",
                "codigo": 5705,
                "ciudad": "PUTAENDO"
            },
            {
                "comuna": "SANTA MARIA",
                "codigo": 5706,
                "ciudad": "SANTA MARIA"
            }
        ]
    },
    "6": {
        "nombreRegion": "Región de O’Higgins",
        "comunas": [
            {
                "comuna": "RANCAGUA",
                "codigo": 6101,
                "ciudad": "RANCAGUA"
            },
            {
                "comuna": "COINCO",
                "codigo": 6103,
                "ciudad": "COINCO"
            },
            {
                "comuna": "COLTAUCO",
                "codigo": 6104,
                "ciudad": "COLTAUCO"
            },
            {
                "comuna": "DONIHUE",
                "codigo": 6105,
                "ciudad": "DONIHUE"
            },
            {
                "comuna": "GRANEROS",
                "codigo": 6106,
                "ciudad": "GRANEROS"
            },
            {
                "comuna": "LAS CABRAS",
                "codigo": 6107,
                "ciudad": "LAS CABRAS"
            },
            {
                "comuna": "MACHALI",
                "codigo": 6108,
                "ciudad": "MACHALI"
            },
            {
                "comuna": "MALLOA",
                "codigo": 6109,
                "ciudad": "MALLOA"
            },
            {
                "comuna": "MOSTAZAL",
                "codigo": 6110,
                "ciudad": "RANCAGUA"
            },
            {
                "comuna": "OLIVAR",
                "codigo": 6111,
                "ciudad": "OLIVAR"
            },
            {
                "comuna": "PEUMO",
                "codigo": 6112,
                "ciudad": "PEUMO"
            },
            {
                "comuna": "PICHIDEGUA",
                "codigo": 6113,
                "ciudad": "PICHIDEGUA"
            },
            {
                "comuna": "QUINTA DE TILCOCO",
                "codigo": 6114,
                "ciudad": "QUINTA DE TILCOCO"
            },
            {
                "comuna": "RENGO",
                "codigo": 6115,
                "ciudad": "RENGO"
            },
            {
                "comuna": "REQUINOA",
                "codigo": 6116,
                "ciudad": "REQUINOA"
            },
            {
                "comuna": "SAN VICENTE",
                "codigo": 6117,
                "ciudad": "SAN VICENTE"
            },
            {
                "comuna": "PICHILEMU",
                "codigo": 6201,
                "ciudad": "PICHILEMU"
            },
            {
                "comuna": "LA ESTRELLA",
                "codigo": 6202,
                "ciudad": "LA ESTRELLA"
            },
            {
                "comuna": "LITUECHE",
                "codigo": 6203,
                "ciudad": "LITUECHE"
            },
            {
                "comuna": "MARCHIHUE",
                "codigo": 6204,
                "ciudad": "MARCHIHUE"
            },
            {
                "comuna": "NAVIDAD",
                "codigo": 6205,
                "ciudad": "NAVIDAD"
            },
            {
                "comuna": "PAREDONES",
                "codigo": 6206,
                "ciudad": "PAREDONES"
            },
            {
                "comuna": "SAN FERNANDO",
                "codigo": 6301,
                "ciudad": "SAN FERNANDO"
            },
            {
                "comuna": "CHEPICA",
                "codigo": 6302,
                "ciudad": "CHEPICA"
            },
            {
                "comuna": "CHIMBARONGO",
                "codigo": 6303,
                "ciudad": "CHIMBARONGO"
            },
            {
                "comuna": "LOLOL",
                "codigo": 6304,
                "ciudad": "LOLOL"
            },
            {
                "comuna": "NANCAGUA",
                "codigo": 6305,
                "ciudad": "NANCAGUA"
            },
            {
                "comuna": "PALMILLA",
                "codigo": 6306,
                "ciudad": "PALMILLA"
            },
            {
                "comuna": "PERALILLO",
                "codigo": 6307,
                "ciudad": "PERALILLO"
            },
            {
                "comuna": "PLACILLA",
                "codigo": 6308,
                "ciudad": "PLACILLA"
            },
            {
                "comuna": "PUMANQUE",
                "codigo": 6309,
                "ciudad": "PUMANQUE"
            },
            {
                "comuna": "SANTA CRUZ",
                "codigo": 6310,
                "ciudad": "SANTA CRUZ"
            },
            {
                "comuna": "CODEGUA",
                "codigo": 6102,
                "ciudad": "CODEGUA"
            }
        ]
    },
    "7": {
        "nombreRegion": "Región del Maule",
        "comunas": [
            {
                "comuna": "SAGRADA FAMILIA",
                "codigo": 7307,
                "ciudad": "SAGRADA FAMILIA"
            },
            {
                "comuna": "TENO",
                "codigo": 7308,
                "ciudad": "TENO"
            },
            {
                "comuna": "VICHUQUEN",
                "codigo": 7309,
                "ciudad": "VICHUQUEN"
            },
            {
                "comuna": "LINARES",
                "codigo": 7401,
                "ciudad": "LINARES"
            },
            {
                "comuna": "COLBUN",
                "codigo": 7402,
                "ciudad": "COLBUN"
            },
            {
                "comuna": "LONGAVI",
                "codigo": 7403,
                "ciudad": "LONGAVI"
            },
            {
                "comuna": "PARRAL",
                "codigo": 7404,
                "ciudad": "PARRAL"
            },
            {
                "comuna": "RETIRO",
                "codigo": 7405,
                "ciudad": "RETIRO"
            },
            {
                "comuna": "SAN JAVIER",
                "codigo": 7406,
                "ciudad": "SAN JAVIER"
            },
            {
                "comuna": "VILLA ALEGRE",
                "codigo": 7407,
                "ciudad": "VILLA ALEGRE"
            },
            {
                "comuna": "YERBAS BUENAS",
                "codigo": 7408,
                "ciudad": "YERBAS BUENAS"
            },
            {
                "comuna": "TALCA",
                "codigo": 7101,
                "ciudad": "TALCA"
            },
            {
                "comuna": "CONSTITUCION",
                "codigo": 7102,
                "ciudad": "CONSTITUCION"
            },
            {
                "comuna": "CUREPTO",
                "codigo": 7103,
                "ciudad": "CUREPTO"
            },
            {
                "comuna": "EMPEDRADO",
                "codigo": 7104,
                "ciudad": "EMPEDRADO"
            },
            {
                "comuna": "MAULE",
                "codigo": 7105,
                "ciudad": "MAULE"
            },
            {
                "comuna": "PELARCO",
                "codigo": 7106,
                "ciudad": "PELARCO"
            },
            {
                "comuna": "PENCAHUE",
                "codigo": 7107,
                "ciudad": "PENCAHUE"
            },
            {
                "comuna": "RIO CLARO",
                "codigo": 7108,
                "ciudad": "RIO CLARO"
            },
            {
                "comuna": "SAN CLEMENTE",
                "codigo": 7109,
                "ciudad": "SAN CLEMENTE"
            },
            {
                "comuna": "SAN RAFAEL",
                "codigo": 7110,
                "ciudad": "SAN RAFAEL"
            },
            {
                "comuna": "CAUQUENES",
                "codigo": 7201,
                "ciudad": "CAUQUENES"
            },
            {
                "comuna": "CHANCO",
                "codigo": 7202,
                "ciudad": "CHANCO"
            },
            {
                "comuna": "PELLUHUE",
                "codigo": 7203,
                "ciudad": "PELLUHUE"
            },
            {
                "comuna": "CURICO",
                "codigo": 7301,
                "ciudad": "CURICO"
            },
            {
                "comuna": "HUALANE",
                "codigo": 7302,
                "ciudad": "HUALANE"
            },
            {
                "comuna": "LICANTEN",
                "codigo": 7303,
                "ciudad": "LICANTEN"
            },
            {
                "comuna": "MOLINA",
                "codigo": 7304,
                "ciudad": "MOLINA"
            },
            {
                "comuna": "RAUCO",
                "codigo": 7305,
                "ciudad": "RAUCO"
            },
            {
                "comuna": "ROMERAL",
                "codigo": 7306,
                "ciudad": "ROMERAL"
            }
        ]
    },
    "8": {
        "nombreRegion": "Región del Biobío",
        "comunas": [
            {
                "comuna": "CONCEPCION",
                "codigo": 8101,
                "ciudad": "CONCEPCION"
            },
            {
                "comuna": "CORONEL",
                "codigo": 8102,
                "ciudad": "CORONEL"
            },
            {
                "comuna": "HUALPEN",
                "codigo": 8112,
                "ciudad": "HUALPEN"
            },
            {
                "comuna": "ALTO BIO BIO",
                "codigo": 8314,
                "ciudad": "ALTO BIO BIO"
            },
            {
                "comuna": "CHIGUAYANTE",
                "codigo": 8103,
                "ciudad": "CONCEPCION"
            },
            {
                "comuna": "FLORIDA",
                "codigo": 8104,
                "ciudad": "FLORIDA"
            },
            {
                "comuna": "HUALQUI",
                "codigo": 8105,
                "ciudad": "CONCEPCION"
            },
            {
                "comuna": "LOTA",
                "codigo": 8106,
                "ciudad": "LOTA"
            },
            {
                "comuna": "PENCO",
                "codigo": 8107,
                "ciudad": "PENCO"
            },
            {
                "comuna": "SAN PEDRO DE LA PAZ",
                "codigo": 8108,
                "ciudad": "SAN PEDRO DE LA PAZ"
            },
            {
                "comuna": "SANTA JUANA",
                "codigo": 8109,
                "ciudad": "SANTA JUANA"
            },
            {
                "comuna": "TALCAHUANO",
                "codigo": 8110,
                "ciudad": "TALCAHUANO"
            },
            {
                "comuna": "TOME",
                "codigo": 8111,
                "ciudad": "TOME"
            },
            {
                "comuna": "LEBU",
                "codigo": 8201,
                "ciudad": "LEBU"
            },
            {
                "comuna": "ARAUCO",
                "codigo": 8202,
                "ciudad": "ARAUCO"
            },
            {
                "comuna": "CANETE",
                "codigo": 8203,
                "ciudad": "CANETE"
            },
            {
                "comuna": "CONTULMO",
                "codigo": 8204,
                "ciudad": "CONTULMO"
            },
            {
                "comuna": "CURANILAHUE",
                "codigo": 8205,
                "ciudad": "CURANILAHUE"
            },
            {
                "comuna": "LOS ALAMOS",
                "codigo": 8206,
                "ciudad": "LOS ALAMOS"
            },
            {
                "comuna": "TIRUA",
                "codigo": 8207,
                "ciudad": "TIRUA"
            },
            {
                "comuna": "LOS ANGELES",
                "codigo": 8301,
                "ciudad": "LOS ANGELES"
            },
            {
                "comuna": "ANTUCO",
                "codigo": 8302,
                "ciudad": "ANTUCO"
            },
            {
                "comuna": "CABRERO",
                "codigo": 8303,
                "ciudad": "CABRERO"
            },
            {
                "comuna": "LAJA",
                "codigo": 8304,
                "ciudad": "LAJA"
            },
            {
                "comuna": "MULCHEN",
                "codigo": 8305,
                "ciudad": "MULCHEN"
            },
            {
                "comuna": "NACIMIENTO",
                "codigo": 8306,
                "ciudad": "NACIMIENTO"
            },
            {
                "comuna": "NEGRETE",
                "codigo": 8307,
                "ciudad": "NEGRETE"
            },
            {
                "comuna": "QUILACO",
                "codigo": 8308,
                "ciudad": "QUILACO"
            },
            {
                "comuna": "QUILLECO",
                "codigo": 8309,
                "ciudad": "QUILLECO"
            },
            {
                "comuna": "SAN ROSENDO",
                "codigo": 8310,
                "ciudad": "SAN ROSENDO"
            },
            {
                "comuna": "SANTA BARBARA",
                "codigo": 8311,
                "ciudad": "SANTA BARBARA"
            },
            {
                "comuna": "TUCAPEL",
                "codigo": 8312,
                "ciudad": "TUCAPEL"
            },
            {
                "comuna": "YUMBEL",
                "codigo": 8313,
                "ciudad": "YUMBEL"
            }
        ]
    },
    "9": {
        "nombreRegion": "Región de La Araucanía",
        "comunas": [
            {
                "comuna": "CHOL CHOL",
                "codigo": 9121,
                "ciudad": "CHOL CHOL"
            },
            {
                "comuna": "TEMUCO",
                "codigo": 9101,
                "ciudad": "TEMUCO"
            },
            {
                "comuna": "CARAHUE",
                "codigo": 9102,
                "ciudad": "CARAHUE"
            },
            {
                "comuna": "CUNCO",
                "codigo": 9103,
                "ciudad": "CUNCO"
            },
            {
                "comuna": "CURARREHUE",
                "codigo": 9104,
                "ciudad": "CURARREHUE"
            },
            {
                "comuna": "FREIRE",
                "codigo": 9105,
                "ciudad": "FREIRE"
            },
            {
                "comuna": "GALVARINO",
                "codigo": 9106,
                "ciudad": "GALVARINO"
            },
            {
                "comuna": "GORBEA",
                "codigo": 9107,
                "ciudad": "GORBEA"
            },
            {
                "comuna": "LAUTARO",
                "codigo": 9108,
                "ciudad": "LAUTARO"
            },
            {
                "comuna": "LONCOCHE",
                "codigo": 9109,
                "ciudad": "LONCOCHE"
            },
            {
                "comuna": "MELIPEUCO",
                "codigo": 9110,
                "ciudad": "MELIPEUCO"
            },
            {
                "comuna": "NUEVA IMPERIAL",
                "codigo": 9111,
                "ciudad": "NUEVA IMPERIAL"
            },
            {
                "comuna": "PADRE LAS CASAS",
                "codigo": 9112,
                "ciudad": "TEMUCO"
            },
            {
                "comuna": "PERQUENCO",
                "codigo": 9113,
                "ciudad": "PERQUENCO"
            },
            {
                "comuna": "PITRUFQUEN",
                "codigo": 9114,
                "ciudad": "PITRUFQUEN"
            },
            {
                "comuna": "PUCON",
                "codigo": 9115,
                "ciudad": "PUCON"
            },
            {
                "comuna": "SAAVEDRA",
                "codigo": 9116,
                "ciudad": "SAAVEDRA"
            },
            {
                "comuna": "TEODORO SCHMIDT",
                "codigo": 9117,
                "ciudad": "TEODORO SCHMIDT"
            },
            {
                "comuna": "TOLTEN",
                "codigo": 9118,
                "ciudad": "TOLTEN"
            },
            {
                "comuna": "VILCUN",
                "codigo": 9119,
                "ciudad": "VILCUN"
            },
            {
                "comuna": "VILLARRICA",
                "codigo": 9120,
                "ciudad": "VILLARRICA"
            },
            {
                "comuna": "ANGOL",
                "codigo": 9201,
                "ciudad": "ANGOL"
            },
            {
                "comuna": "COLLIPULLI",
                "codigo": 9202,
                "ciudad": "COLLIPULLI"
            },
            {
                "comuna": "CURACAUTIN",
                "codigo": 9203,
                "ciudad": "CURACAUTIN"
            },
            {
                "comuna": "ERCILLA",
                "codigo": 9204,
                "ciudad": "ERCILLA"
            },
            {
                "comuna": "LONQUIMAY",
                "codigo": 9205,
                "ciudad": "LONQUIMAY"
            },
            {
                "comuna": "LOS SAUCES",
                "codigo": 9206,
                "ciudad": "LOS SAUCES"
            },
            {
                "comuna": "LUMACO",
                "codigo": 9207,
                "ciudad": "LUMACO"
            },
            {
                "comuna": "PUREN",
                "codigo": 9208,
                "ciudad": "PUREN"
            },
            {
                "comuna": "RENAICO",
                "codigo": 9209,
                "ciudad": "RENAICO"
            },
            {
                "comuna": "TRAIGUEN",
                "codigo": 9210,
                "ciudad": "TRAIGUEN"
            },
            {
                "comuna": "VICTORIA",
                "codigo": 9211,
                "ciudad": "VICTORIA"
            }
        ]
    },
    "10": {
        "nombreRegion": "Región de Los Lagos",
        "comunas": [
            {
                "comuna": "COCHAMO",
                "codigo": 10103,
                "ciudad": "COCHAMO"
            },
            {
                "comuna": "FRESIA",
                "codigo": 10104,
                "ciudad": "FRESIA"
            },
            {
                "comuna": "FRUTILLAR",
                "codigo": 10105,
                "ciudad": "FRUTILLAR"
            },
            {
                "comuna": "LOS MUERMOS",
                "codigo": 10106,
                "ciudad": "LOS MUERMOS"
            },
            {
                "comuna": "LLANQUIHUE",
                "codigo": 10107,
                "ciudad": "LLANQUIHUE"
            },
            {
                "comuna": "MAULLIN",
                "codigo": 10108,
                "ciudad": "MAULLIN"
            },
            {
                "comuna": "PUERTO VARAS",
                "codigo": 10109,
                "ciudad": "PUERTO VARAS"
            },
            {
                "comuna": "CASTRO",
                "codigo": 10201,
                "ciudad": "CASTRO"
            },
            {
                "comuna": "ANCUD",
                "codigo": 10202,
                "ciudad": "ANCUD"
            },
            {
                "comuna": "CHONCHI",
                "codigo": 10203,
                "ciudad": "CHONCHI"
            },
            {
                "comuna": "CURACO DE VELEZ",
                "codigo": 10204,
                "ciudad": "CURACO DE VELEZ"
            },
            {
                "comuna": "DALCAHUE",
                "codigo": 10205,
                "ciudad": "CASTRO"
            },
            {
                "comuna": "PUQUELDON",
                "codigo": 10206,
                "ciudad": "PUQUELDON"
            },
            {
                "comuna": "QUEILEN",
                "codigo": 10207,
                "ciudad": "QUEILEN"
            },
            {
                "comuna": "QUELLON",
                "codigo": 10208,
                "ciudad": "QUELLON"
            },
            {
                "comuna": "PUERTO MONTT",
                "codigo": 10101,
                "ciudad": "PUERTO MONTT"
            },
            {
                "comuna": "CALBUCO",
                "codigo": 10102,
                "ciudad": "CALBUCO"
            },
            {
                "comuna": "QUEMCHI",
                "codigo": 10209,
                "ciudad": "QUEMCHI"
            },
            {
                "comuna": "QUINCHAO",
                "codigo": 10210,
                "ciudad": "QUINCHAO"
            },
            {
                "comuna": "OSORNO",
                "codigo": 10301,
                "ciudad": "OSORNO"
            },
            {
                "comuna": "PUERTO OCTAY",
                "codigo": 10302,
                "ciudad": "PUERTO OCTAY"
            },
            {
                "comuna": "PURRANQUE",
                "codigo": 10303,
                "ciudad": "PURRANQUE"
            },
            {
                "comuna": "PUYEHUE",
                "codigo": 10304,
                "ciudad": "PUYEHUE"
            },
            {
                "comuna": "RIO NEGRO",
                "codigo": 10305,
                "ciudad": "RIO NEGRO"
            },
            {
                "comuna": "SAN JUAN DE LA COSTA",
                "codigo": 10306,
                "ciudad": "SAN JUAN DE LA COSTA"
            },
            {
                "comuna": "SAN PABLO",
                "codigo": 10307,
                "ciudad": "SAN PABLO"
            },
            {
                "comuna": "CHAITEN",
                "codigo": 10401,
                "ciudad": "CHAITEN"
            },
            {
                "comuna": "FUTALEUFU",
                "codigo": 10402,
                "ciudad": "FUTALEUFU"
            },
            {
                "comuna": "HUALAIHUE",
                "codigo": 10403,
                "ciudad": "HUALAIHUE"
            },
            {
                "comuna": "PALENA",
                "codigo": 10404,
                "ciudad": "PALENA"
            }
        ]
    },
    "11": {
        "nombreRegion": "Región de Aysén",
        "comunas": [
            {
                "comuna": "COIHAIQUE",
                "codigo": 11101,
                "ciudad": "COIHAIQUE"
            },
            {
                "comuna": "LAGO VERDE",
                "codigo": 11102,
                "ciudad": "LAGO VERDE"
            },
            {
                "comuna": "AISEN",
                "codigo": 11201,
                "ciudad": "AISEN"
            },
            {
                "comuna": "CISNES",
                "codigo": 11202,
                "ciudad": "CISNES"
            },
            {
                "comuna": "GUAITECAS",
                "codigo": 11203,
                "ciudad": "GUAITECAS"
            },
            {
                "comuna": "COCHRANE",
                "codigo": 11301,
                "ciudad": "COCHRANE"
            },
            {
                "comuna": "O'HIGGINS",
                "codigo": 11302,
                "ciudad": "O'HIGGINS"
            },
            {
                "comuna": "TORTEL",
                "codigo": 11303,
                "ciudad": "TORTEL"
            },
            {
                "comuna": "CHILE CHICO",
                "codigo": 11401,
                "ciudad": "CHILE CHICO"
            },
            {
                "comuna": "RIO IBANEZ",
                "codigo": 11402,
                "ciudad": "RIO IBANEZ"
            }
        ]
    },
    "12": {
        "nombreRegion": "Región de Magallanes",
        "comunas": [
            {
                "comuna": "CABO DE HORNOS",
                "codigo": 12201,
                "ciudad": "CABO DE HORNOS"
            },
            {
                "comuna": "ANTARTICA",
                "codigo": 12202,
                "ciudad": "ANTARTICA"
            },
            {
                "comuna": "PORVENIR",
                "codigo": 12301,
                "ciudad": "PORVENIR"
            },
            {
                "comuna": "PRIMAVERA",
                "codigo": 12302,
                "ciudad": "PRIMAVERA"
            },
            {
                "comuna": "TIMAUKEL",
                "codigo": 12303,
                "ciudad": "TIMAUKEL"
            },
            {
                "comuna": "PUERTO NATALES",
                "codigo": 12401,
                "ciudad": "PUERTO NATALES"
            },
            {
                "comuna": "TORRES DEL PAINE",
                "codigo": 12402,
                "ciudad": "PUERTO NATALES"
            },
            {
                "comuna": "PUNTA ARENAS",
                "codigo": 12101,
                "ciudad": "PUNTA ARENAS"
            },
            {
                "comuna": "LAGUNA BLANCA",
                "codigo": 12102,
                "ciudad": "LAGUNA BLANCA"
            },
            {
                "comuna": "RIO VERDE",
                "codigo": 12103,
                "ciudad": "RIO VERDE"
            },
            {
                "comuna": "SAN GREGORIO",
                "codigo": 12104,
                "ciudad": "SAN GREGORIO"
            }
        ]
    },
    "13": {
        "nombreRegion": "Región Metropolitana",
        "comunas": [
            {
                "comuna": "SANTIAGO",
                "codigo": 13101,
                "ciudad": "SANTIAGO"
            },
            {
                "comuna": "CERRILLOS",
                "codigo": 13102,
                "ciudad": "SANTIAGO"
            },
            {
                "comuna": "CERRO NAVIA",
                "codigo": 13103,
                "ciudad": "SANTIAGO"
            },
            {
                "comuna": "CONCHALI",
                "codigo": 13104,
                "ciudad": "SANTIAGO"
            },
            {
                "comuna": "EL BOSQUE",
                "codigo": 13105,
                "ciudad": "SANTIAGO"
            },
            {
                "comuna": "ESTACION CENTRAL",
                "codigo": 13106,
                "ciudad": "SANTIAGO"
            },
            {
                "comuna": "HUECHURABA",
                "codigo": 13107,
                "ciudad": "SANTIAGO"
            },
            {
                "comuna": "INDEPENDENCIA",
                "codigo": 13108,
                "ciudad": "SANTIAGO"
            },
            {
                "comuna": "LA CISTERNA",
                "codigo": 13109,
                "ciudad": "SANTIAGO"
            },
            {
                "comuna": "LA FLORIDA",
                "codigo": 13110,
                "ciudad": "SANTIAGO"
            },
            {
                "comuna": "LA GRANJA",
                "codigo": 13111,
                "ciudad": "SANTIAGO"
            },
            {
                "comuna": "LA PINTANA",
                "codigo": 13112,
                "ciudad": "SANTIAGO"
            },
            {
                "comuna": "LA REINA",
                "codigo": 13113,
                "ciudad": "SANTIAGO"
            },
            {
                "comuna": "LAS CONDES",
                "codigo": 13114,
                "ciudad": "SANTIAGO"
            },
            {
                "comuna": "LO BARNECHEA",
                "codigo": 13115,
                "ciudad": "SANTIAGO"
            },
            {
                "comuna": "LO ESPEJO",
                "codigo": 13116,
                "ciudad": "SANTIAGO"
            },
            {
                "comuna": "LO PRADO",
                "codigo": 13117,
                "ciudad": "SANTIAGO"
            },
            {
                "comuna": "MACUL",
                "codigo": 13118,
                "ciudad": "SANTIAGO"
            },
            {
                "comuna": "MAIPU",
                "codigo": 13119,
                "ciudad": "SANTIAGO"
            },
            {
                "comuna": "NUNOA",
                "codigo": 13120,
                "ciudad": "SANTIAGO"
            },
            {
                "comuna": "PEDRO AGUIRRE CERDA",
                "codigo": 13121,
                "ciudad": "SANTIAGO"
            },
            {
                "comuna": "PENALOLEN",
                "codigo": 13122,
                "ciudad": "SANTIAGO"
            },
            {
                "comuna": "PROVIDENCIA",
                "codigo": 13123,
                "ciudad": "SANTIAGO"
            },
            {
                "comuna": "PUDAHUEL",
                "codigo": 13124,
                "ciudad": "SANTIAGO"
            },
            {
                "comuna": "QUILICURA",
                "codigo": 13125,
                "ciudad": "SANTIAGO"
            },
            {
                "comuna": "QUINTA NORMAL",
                "codigo": 13126,
                "ciudad": "SANTIAGO"
            },
            {
                "comuna": "RENCA",
                "codigo": 13128,
                "ciudad": "SANTIAGO"
            },
            {
                "comuna": "SAN JOAQUIN",
                "codigo": 13129,
                "ciudad": "SANTIAGO"
            },
            {
                "comuna": "SAN MIGUEL",
                "codigo": 13130,
                "ciudad": "SANTIAGO"
            },
            {
                "comuna": "SAN RAMON",
                "codigo": 13131,
                "ciudad": "SANTIAGO"
            },
            {
                "comuna": "VITACURA",
                "codigo": 13132,
                "ciudad": "SANTIAGO"
            },
            {
                "comuna": "PUENTE ALTO",
                "codigo": 13201,
                "ciudad": "SANTIAGO"
            },
            {
                "comuna": "PIRQUE",
                "codigo": 13202,
                "ciudad": "SANTIAGO"
            },
            {
                "comuna": "SAN JOSE DE MAIPO",
                "codigo": 13203,
                "ciudad": "SANTIAGO"
            },
            {
                "comuna": "COLINA",
                "codigo": 13301,
                "ciudad": "SANTIAGO"
            },
            {
                "comuna": "LAMPA",
                "codigo": 13302,
                "ciudad": "SANTIAGO"
            },
            {
                "comuna": "TILTIL",
                "codigo": 13303,
                "ciudad": "SANTIAGO"
            },
            {
                "comuna": "SAN BERNARDO",
                "codigo": 13401,
                "ciudad": "SANTIAGO"
            },
            {
                "comuna": "BUIN",
                "codigo": 13402,
                "ciudad": "SANTIAGO"
            },
            {
                "comuna": "CALERA DE TANGO",
                "codigo": 13403,
                "ciudad": "SANTIAGO"
            },
            {
                "comuna": "PAINE",
                "codigo": 13404,
                "ciudad": "SANTIAGO"
            },
            {
                "comuna": "MELIPILLA",
                "codigo": 13501,
                "ciudad": "SANTIAGO"
            },
            {
                "comuna": "ALHUE",
                "codigo": 13502,
                "ciudad": "SANTIAGO"
            },
            {
                "comuna": "CURACAVI",
                "codigo": 13503,
                "ciudad": "SANTIAGO"
            },
            {
                "comuna": "MARIA PINTO",
                "codigo": 13504,
                "ciudad": "SANTIAGO"
            },
            {
                "comuna": "SAN PEDRO",
                "codigo": 13505,
                "ciudad": "SAN PEDRO"
            },
            {
                "comuna": "TALAGANTE",
                "codigo": 13601,
                "ciudad": "SANTIAGO"
            },
            {
                "comuna": "EL MONTE",
                "codigo": 13602,
                "ciudad": "SANTIAGO"
            },
            {
                "comuna": "ISLA DE MAIPO",
                "codigo": 13603,
                "ciudad": "SANTIAGO"
            },
            {
                "comuna": "PADRE HURTADO",
                "codigo": 13604,
                "ciudad": "SANTIAGO"
            },
            {
                "comuna": "PENAFLOR",
                "codigo": 13605,
                "ciudad": "SANTIAGO"
            },
            {
                "comuna": "RECOLETA",
                "codigo": 13127,
                "ciudad": "SANTIAGO"
            }
        ]
    },
    "14": {
        "nombreRegion": "Región de Los Ríos",
        "comunas": [
            {
                "comuna": "VALDIVIA",
                "codigo": 14101,
                "ciudad": "VALDIVIA"
            },
            {
                "comuna": "CORRAL",
                "codigo": 14102,
                "ciudad": "CORRAL"
            },
            {
                "comuna": "FUTRONO",
                "codigo": 14202,
                "ciudad": "FUTRONO"
            },
            {
                "comuna": "LA UNION",
                "codigo": 14201,
                "ciudad": "LA UNION"
            },
            {
                "comuna": "LAGO RANCO",
                "codigo": 14203,
                "ciudad": "LAGO RANCO"
            },
            {
                "comuna": "LANCO",
                "codigo": 14103,
                "ciudad": "LANCO"
            },
            {
                "comuna": "LOS LAGOS",
                "codigo": 14104,
                "ciudad": "LOS LAGOS"
            },
            {
                "comuna": "MAFIL",
                "codigo": 14105,
                "ciudad": "MAFIL"
            },
            {
                "comuna": "MARIQUINA",
                "codigo": 14106,
                "ciudad": "MARIQUINA"
            },
            {
                "comuna": "PAILLACO",
                "codigo": 14107,
                "ciudad": "PAILLACO"
            },
            {
                "comuna": "PANGUIPULLI",
                "codigo": 14108,
                "ciudad": "PANGUIPULLI"
            },
            {
                "comuna": "RIO BUENO",
                "codigo": 14204,
                "ciudad": "RIO BUENO"
            }
        ]
    },
    "15": {
        "nombreRegion": "Región de Arica y Parinacota",
        "comunas": [
            {
                "comuna": "ARICA",
                "codigo": 15101,
                "ciudad": "ARICA"
            },
            {
                "comuna": "CAMARONES",
                "codigo": 15102,
                "ciudad": "CAMARONES"
            },
            {
                "comuna": "PUTRE",
                "codigo": 15201,
                "ciudad": "PUTRE"
            },
            {
                "comuna": "GENERAL LAGOS",
                "codigo": 15202,
                "ciudad": "GENERAL LAGOS"
            }
        ]
    },
    "16": {
        "nombreRegion": "Región del Nuble",
        "comunas": [
            {
                "comuna": "CHILLAN",
                "codigo": 16101,
                "ciudad": "CHILLAN"
            },
            {
                "comuna": "BULNES",
                "codigo": 16102,
                "ciudad": "BULNES"
            },
            {
                "comuna": "CHILLAN VIEJO",
                "codigo": 16103,
                "ciudad": "CHILLAN"
            },
            {
                "comuna": "EL CARMEN",
                "codigo": 16104,
                "ciudad": "EL CARMEN"
            },
            {
                "comuna": "PEMUCO",
                "codigo": 16105,
                "ciudad": "PEMUCO"
            },
            {
                "comuna": "PINTO",
                "codigo": 16106,
                "ciudad": "PINTO"
            },
            {
                "comuna": "QUILLON",
                "codigo": 16107,
                "ciudad": "QUILLON"
            },
            {
                "comuna": "SAN IGNACIO",
                "codigo": 16108,
                "ciudad": "SAN IGNACIO"
            },
            {
                "comuna": "YUNGAY",
                "codigo": 16109,
                "ciudad": "YUNGAY"
            },
            {
                "comuna": "QUIRIHUE",
                "codigo": 16201,
                "ciudad": "QUIRIHUE"
            },
            {
                "comuna": "COBQUECURA",
                "codigo": 16202,
                "ciudad": "COBQUECURA"
            },
            {
                "comuna": "COELEMU",
                "codigo": 16203,
                "ciudad": "COELEMU"
            },
            {
                "comuna": "NINHUE",
                "codigo": 16204,
                "ciudad": "NINHUE"
            },
            {
                "comuna": "PORTEZUELO",
                "codigo": 16205,
                "ciudad": "PORTEZUELO"
            },
            {
                "comuna": "RANQUIL",
                "codigo": 16206,
                "ciudad": "RANQUIL"
            },
            {
                "comuna": "TREGUACO",
                "codigo": 16207,
                "ciudad": "TREGUACO"
            },
            {
                "comuna": "SAN CARLOS",
                "codigo": 16301,
                "ciudad": "SAN CARLOS"
            },
            {
                "comuna": "COIHUECO",
                "codigo": 16302,
                "ciudad": "COIHUECO"
            },
            {
                "comuna": "NIQUEN",
                "codigo": 16303,
                "ciudad": "NIQUEN"
            },
            {
                "comuna": "SAN FABIAN",
                "codigo": 16304,
                "ciudad": "SAN FABIAN"
            },
            {
                "comuna": "SAN NICOLAS",
                "codigo": 16305,
                "ciudad": "SAN NICOLAS"
            }
        ]
    }
}